// extracted by mini-css-extract-plugin
module.exports = {"modalRoot":"az_HDb","disableScrollBar":"az_IDb","modalTooltip":"az_JDb"};